import api from '../..'

const destroyExternalCourseParticipant = (id: number | string) => {
  return api.delete(`/administration/external_course_participant/${id}`)
}

export default destroyExternalCourseParticipant
